export const coverageBlockContent = {
  heading: 'Reliable network by',
  logoAlt: 'VodafoneThree',
  coverageLinkTo: '/coverage-checker',
  coverageLinkDataTestId: 'coverage-link',
  fullCoverageText: 'Check your coverage here',
  coverageStat: '99.5%',
  coverageSuffix: 'coverage (outdoors),',
  checkCoverageText: 'check yours here',
}
